import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import GuideStepContainer from '../layout';
import LevelItems from './levelItems';
import { selectStep, nextStep } from '../../../actions/gameGuideActions';
// Game(kit) imports
import gameKit from '../../../../GameKit';
// Level editor
import { itemSelectorToggle } from '../../../actions/levelEditorActions';
// Shared imports
import { GuideStepEnum } from '../../../shared';
import settings from '../../../../settings';
// Popup imports
import LevelSettingsModeEnum from '../../Popup/Types/LevelSettings/enums';
import { OpenPopup } from '../../../actions/popupActions';
import { PopupTypes, PopupStates } from '../../Popup/Enums';
import { GameGoalFlag } from '../../../../Game/Enums';
import PlayerPreview from '../GuideStepPlayer/playerPreview';

class GuideStepLevel extends React.Component {
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.items = this.items.splice(oldIndex, 0, this.items.splice(newIndex, 1)[0]);
    };

    onSelectPlayerStep = () => {
        const { dispatch } = this.props;
        dispatch(selectStep(GuideStepEnum.SPELER));
    };

    onSelectGoalStep = () => {
        const { dispatch } = this.props;
        dispatch(selectStep(GuideStepEnum.DOEL_SCORE));
    };

    onPublishButton = () => {
        const { dispatch } = this.props;
        dispatch(nextStep());
    };

    onAdd = () => {
        gameKit.createNewLevel();

        const { game, levelEditor, dispatch } = this.props;
        const { levels } = game;

        const newLevel = levels[levels.length - 1];
        gameKit.openLevel(newLevel.uuid);

        if (levelEditor.itemSelectorOpen) {
            dispatch(itemSelectorToggle());
        }

        dispatch(
            OpenPopup(PopupTypes.LEVEL_SETTINGS, PopupStates.DEFAULT, {
                mode: LevelSettingsModeEnum.LEVEL_VIEW,
                initial: true,
                levelUuid: newLevel.uuid
            })
        );
    };

    LevelTitle = () => {
        const { game } = this.props;
        const { goal } = game;

        const goalImages = [];
        if (goal & GameGoalFlag.FINISH) {
            goalImages.push(<img src={`${settings.assetsPath}img/icons/finish.png`} alt="Spel doel Finish" key={GameGoalFlag.FINISH} />);
        }
        if (goal & GameGoalFlag.POINT_LIMIT) {
            goalImages.push(<img src={`${settings.assetsPath}img/icons/muntje.png`} alt="Spel doel Punten" key={GameGoalFlag.POINT_LIMIT} />);
        }
        if (goal & GameGoalFlag.TIME_LIMIT) {
            goalImages.push(<img src={`${settings.assetsPath}img/icons/klock.png`} alt="Spel doel Tijd" key={GameGoalFlag.TIME_LIMIT} />);
        }

        // If none of the settings are set, set 'DIE' as game goal
        if (goal === GameGoalFlag.DIE) {
            goalImages.push(<img src={`${settings.assetsPath}img/icons/dead.png`} alt="Spel doel Overleef" key={GameGoalFlag.DIE} />);
        }

        return (
            <div className="level-title-container">
                <div className="center">
                    <h1>Levels bouwen</h1>
                </div>
                <div className="prev-steps">
                    <div className="prev-step player-step">
                        <div className="img-container">
                            <PlayerPreview game={game} />
                        </div>
                        <div className="info">
                            <span>Speler</span>
                            <span onClick={this.onSelectPlayerStep}>verander</span>
                        </div>
                    </div>
                    <div className="prev-step goal-step">
                        <div className={`img-container size-${goalImages.length}`}>{goalImages}</div>
                        <div className="info">
                            <span>Speldoel</span>
                            <span onClick={this.onSelectGoalStep}>verander</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    PublishButton = () => {
        const { game } = this.props;
        const { levels } = game;

        if (levels.length > 0) {
            return (
                <div className="btn-publish-container">
                    <img src={`${settings.assetsPath}img/publiceer_monstertje.png`} alt="Monstertje wilt spelen" />
                    <button type="button" onClick={this.onPublishButton} className="btn-publish">
                        publiceer jouw game
                    </button>
                </div>
            );
        }
        return <></>;
    };

    render() {
        const { id } = this.props;

        return (
            <GuideStepContainer titleElement={<this.LevelTitle />} id={id} hasSaveButton>
                <LevelItems />
                <button type="button" onClick={this.onAdd} className="btn-add-level">
                    voeg level toe +
                </button>
                <this.PublishButton />
            </GuideStepContainer>
        );
    }
}

GuideStepLevel.defaultProps = {};

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game,
    levelEditor: state.levelEditor
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GuideStepLevel);
